import { render, staticRenderFns } from "./WsOrgsList.vue?vue&type=template&id=2a792c44"
import script from "./WsOrgsList.vue?vue&type=script&lang=js"
export * from "./WsOrgsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports